import React, { PropsWithChildren, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ResourceType } from '../../@types/i18n'
import { AppBarOptions } from '../../components/layout/AppBar'
import { AppContext } from '../../contexts/AppContext'
import { ModalContext } from '../../contexts/ModalContext'
import ModalLayout from './components/ModalLayout'

export interface ModalWrapperProps {
	appBarOptions?: Partial<AppBarOptions>
}

const ModalWrapper = ({ children, appBarOptions }: PropsWithChildren<ModalWrapperProps>) => {
	const { t } = useTranslation('modals')
	const { modalOnTop } = useContext(ModalContext)
	const { isMobileView } = useContext(AppContext)

	return (
		<div className={isMobileView ? 'min-h-full' : ''}>
			<ModalLayout
				appBarOptions={appBarOptions}
				t={t}
				modalOnTop={modalOnTop as keyof ResourceType['modals']}
			>
				{children}
			</ModalLayout>
		</div>
	)
}

export default ModalWrapper
